/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanitySpenderListInfo = {
    RK: string;
    ADT: HumanitySpenderListInfo.ADT;
    ADDR: string;
    TGU: string;
    TS: string;
    TRXCNT: string;
    TF: string;
    LTRXUT: number;
};

export namespace HumanitySpenderListInfo {

    export enum ADT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

